var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStorybook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "light",
    d: "M14.446.849a.905.905 0 0 1 .001.056v16.19a.905.905 0 0 1-.945.904l-12.08-.542a.905.905 0 0 1-.864-.87L.001 1.728A.905.905 0 0 1 .849.792l9.904-.62-.085 2.04c0 .021.003.042.012.06l.016.028c.045.06.13.07.189.026l.792-.601.67.527a.135.135 0 0 0 .218-.111L12.492.063l.994-.061a.905.905 0 0 1 .96.847Zm-6.95 2.214c-2.355 0-3.675 1.28-3.675 3.199 0 3.343 4.51 3.407 4.51 5.23 0 .512-.25.816-.801.816-.719 0-1.003-.367-.97-1.615 0-.27-2.74-.355-2.823 0-.213 3.023 1.67 3.895 3.826 3.895 2.089 0 3.726-1.113 3.726-3.128 0-3.583-4.578-3.487-4.578-5.262 0-.72.535-.816.852-.816.334 0 .936.059.886 1.402 0 .353 2.371.184 2.69-.064 0-2.397-1.287-3.657-3.643-3.657Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorybook);
export default __webpack_public_path__ + "static/media/storybook.911b152d7018db109e81a4fa6bee2294.svg";
export { ForwardRef as ReactComponent };